/**
 * Checks if the given string contains any invalid characters.
 * Allows only letters, numbers, spaces, and dashes.
 * @param {string | null} value
 * @returns {boolean} true if invalid chars found, false otherwise
 */
export function hasSpecialCharacters(value: any) {
  if (!value) return false;
  const allowedCharsRegex = /^[a-zA-Z0-9\s-]*$/;
  // returns true if there ARE disallowed chars
  return !allowedCharsRegex.test(value);
}

/**
 * Keypress handler to restrict input to allowed characters only.
 * @param {KeyboardEvent} event
 */
export function onKeypressAllowedChars(event: any) {
  const char = String.fromCharCode(event.charCode);
  const allowed = /^[a-zA-Z0-9\s-]$/;
  if (!allowed.test(char)) {
    event.preventDefault();
  }
}

/**
 * Paste handler to prevent pasting invalid characters.
 * @param {ClipboardEvent} event
 */
export function onPasteAllowedChars(event: any) {
  const pasted = (event.clipboardData || window.Clipboard).getData('text');
  if (hasSpecialCharacters(pasted)) {
    event.preventDefault();
  }
}

/**
 * Paste handler to allow only numbers.
 * @param {ClipboardEvent} event
 */
export function onPasteNumbersOnly(event: any) {
  const pasted = (event.clipboardData || window.Clipboard).getData('text');
  const numbersOnly = /^[0-9]*$/;
  if (!numbersOnly.test(pasted)) {
    event.preventDefault();
  }
}

/**
 * Keypress handler to restrict input to numbers only.
 * @param {KeyboardEvent} event
 */
export function onKeypressNumbersOnly(event: any) {
  const char = String.fromCharCode(event.charCode);
  const numbersOnly = /^[0-9]$/;
  if (!numbersOnly.test(char)) {
    event.preventDefault();
  }
}